import { Lock } from "lucide-react";

export function ReadOnlyBanner({
  ownedByOther = false,
}: {
  ownedByOther?: boolean;
}) {
  return (
    <div className="mb-4 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      <Lock className="h-4 w-4 shrink-0" />
      <span>
        {ownedByOther
          ? "View only — this content belongs to another coach."
          : "View only — this content can't be edited in its current state."}
      </span>
    </div>
  );
}
